import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const TopVendorsOne = () => {
    const [vendors, setVendors] = useState([]);

    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const response = await fetch(
                    "https://ecom.brightcodeapp.com/wp-json/dokan/v1/stores?per_page=100"
                );
                const data = await response.json();

                // Sort vendors by rating (highest first)
                const sorted = data.sort((a, b) => {
                    const ratingA = parseFloat(a.rating.rating) || 0;
                    const ratingB = parseFloat(b.rating.rating) || 0;
                    return ratingB - ratingA;
                });

                setVendors(sorted.slice(0, 8)); // show top 8 vendors
            } catch (error) {
                console.error("Failed to fetch vendors:", error);
            }
        };

        fetchVendors();
    }, []);

    return (
        <section className="top-vendors py-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Weekly Top Sellers</h5>
                        <Link
                            to="/vendor"
                            className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                        >
                            All Vendors
                        </Link>
                    </div>
                </div>

                <div className="row gy-4 vendor-card-wrapper">
                    {vendors.map((vendor) => (
                        <div key={vendor.id} className="col-xxl-3 col-lg-4 col-sm-6">
                            <div className="vendor-card text-center px-16 pb-24">
                                <div>
                                    <img
                                        src={vendor.gravatar || vendor.banner}
                                        alt={vendor.store_name}
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            objectFit: "contain",
                                            borderRadius: "50%",     // 👈 makes it round
                                            backgroundColor: "#fff" // optional: nice clean circle bg
                                        }}
                                    />

                                    <h6 className="title mt-32">{vendor.store_name}</h6>
                                    <span className="text-heading text-sm d-block">
                                        {vendor.rating.rating !== "No Ratings found yet"
                                            ? `Rating: ${vendor.rating.rating} (${vendor.rating.count})`
                                            : "No ratings yet"}
                                    </span>
                                    <Link
                                        to="/shop"
                                        className="btn btn-main-two rounded-pill py-6 px-16 text-12 mt-8"
                                    >
                                        Visit Store
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TopVendorsOne;
